import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
export function CtaSection() {
  const gclid = useGclid();
  const href = buildShopUrl(SHOP_URL, gclid);
  return <section className="w-full py-20 px-4" data-id="element-17">
      <div className="max-w-3xl mx-auto text-center" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-cream-card p-8 md:p-12 rounded-2xl shadow-xl border-2 border-forest/20" data-id="element-19">
          <div className="flex items-center justify-center gap-1 mb-4 text-brown" data-id="element-20">
            <span className="text-lg" data-id="element-21">★★★★</span>
            <span className="text-lg opacity-40" data-id="element-22">☆</span>
            <span className="font-serif text-sm text-gray-600 ml-1" data-id="element-23">
              4,4/5 · 876 Hundehalter haben es bewertet
            </span>
          </div>

          <h2 className="font-handwriting text-4xl md:text-5xl text-forest font-bold mb-4" data-id="element-24">
            Hilf auch deinem Hund — natürlich & sanft
          </h2>

          <p className="font-serif text-lg text-gray-700 mb-8 max-w-xl mx-auto" data-id="element-25">
            Natürliche Ballaststoffe für eine gesunde Darmpassage – risikofrei
            testen mit Geld-zurück-Garantie.
          </p>

          <a href={href} onClick={() => trackCTAClick('Hilf auch deinem Hund — natürlich & sanft', 'bottom_cta')} target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-forest hover:bg-forest-light text-white font-serif font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 mb-4" data-id="element-26">
            Jetzt für meinen Hund entdecken →
          </a>

          <p className="font-serif text-[13px] text-gray-500 italic mb-6" data-id="element-27">
            Aufgrund hoher Nachfrage aktuell begrenzt verfügbar — viele
            Hunderunde-Kunden bestellen regelmäßig nach.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm font-serif text-gray-600" data-id="element-28">
            <div className="flex items-center gap-1" data-id="element-29">
              <Check className="w-4 h-4 text-forest" data-id="element-30" />
              <span data-id="element-31">Schneller Versand</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-32">
              <Check className="w-4 h-4 text-forest" data-id="element-33" />
              <span data-id="element-34">Zufriedenheitsgarantie</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-35">
              <Check className="w-4 h-4 text-forest" data-id="element-36" />
              <span data-id="element-37">100% Natürliche Inhaltsstoffe</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}